// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","268":"51517be6","455":"ae3e85ab","551":"8912905c","828":"6cc522b3","977":"5a4c08f0"}[chunkId] + ".chunk.js";
};